import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

const useSaveNotificationSettings = () => {
  return useMutation(
    (params: {
      notification_snoozed?: boolean;
      notifications?: { [key: string]: any };
    }) => servicesUtils.postService("/profile/notifications/", params)
  );
};

export default useSaveNotificationSettings;
